import { cn } from "@/lib/utils";
import { ImageBody, useWishlistImage } from "../api";
import { useContext, useEffect, useState } from "react";
import { Button } from "@/shared/ui/button.tsx";
import { GalleryPreviewContext, GalleryPreviewContextType } from "../context";
import HeartLogo from "@/assets/heart.svg?react"
import HeartFillLogo from "@/assets/heart-filled.svg?react"
import { Loader2 } from "lucide-react";
import DeleteConfirmation from "./DeleteConfirmation";
import { Skeleton } from "@/shared/ui/skeleton";

type Props = {
  image: ImageBody,
}

const ImageSelection = ({ image }: Props) => {

  const [loading, setLoading] = useState(true)

  const [isWishlist, setIsWishlist] = useState(image.wishlist)

  useEffect(() => {
    setLoading(true)
  }, [image])

  const { setOpenPreview, setCurrentImage } = useContext<GalleryPreviewContextType>(GalleryPreviewContext)

  const { wishlistImage } = useWishlistImage()

  const handleExpandClick = () => {
    if (!image.status) {
      setCurrentImage({ id: image.id, url: image.image_url, catalog_item: image.catalogue_item })
      setOpenPreview(true)
    } else if (image.status !== null && image.status.toLowerCase() === "success") {
      setCurrentImage({ id: image.id, url: image.image_url, catalog_item: image.catalogue_item })
      setOpenPreview(true)
    }
  }

  return (
    <div
      className={cn(
        "relative aspect-square overflow-hidden bg-white rounded-xl cursor-pointer transition-all",
        "border",
      )}
      onClick={handleExpandClick}
    >
      {loading && image.catalogue_item !== "video" &&
        <div className="absolute inset-0 z-30 flex items-center justify-center">
          <Loader2 className="animate-spin" />
        </div>
      }
      {image.catalogue_item !== "video"
        ? <img
          src={image.image_url || "/placeholder.svg"}
          alt={image.prompt}
          className={cn("object-cover transition-all hover:scale-110 duration-700 w-full aspect-square")}
          onLoad={() => setLoading(false)}
        />
        : image.status?.toLowerCase() === "success" ? <span className="object-cover aspect-square">
          <video src={image.image_url} className="object-cover" autoPlay loop muted playsInline />
        </span> : <Skeleton className="object-cover aspect-square flex flex-col gap-3 items-center justify-center">
          <Loader2 className="animate-spin" />
          <p className="font-poppins text-sm tracking-wide">Generating Content...</p>
        </Skeleton>
      }

      <DeleteConfirmation image_id={image.id} />

      <Button size="icon" className="rounded-full bg-white hover:text-white animate-wave p-2 absolute bottom-2 size-7 left-2 text-black z-50" onClick={(e) => {
        e.stopPropagation()
        setIsWishlist(prev => !prev)
        wishlistImage(image.id)
      }}>
        {isWishlist ?
          <HeartFillLogo className="text-red-400" fill="red" /> : <HeartLogo />
        }
      </Button>
    </div>
  )
}

export default ImageSelection;
